export default "__VITE_ASSET__y_I3G8qJ__"